const GUEST_AUTH_RETURN_PATH_KEY = "gt_guest_auth_return_path";
const GUEST_AUTH_DISCOVER_RETURN_TO_KEY = "gt_guest_auth_discover_return_to";
const GUEST_AUTH_POST_ONBOARDING_PATH_KEY = "gt_guest_auth_post_onboarding_path";

const CORRIDOR_GUEST_PATH_RE = /^\/discover\/corridor\/([^/?#]+)\/([^/?#]+)/;
const EXPERT_GUEST_PATH_RE = /^\/discover\/expert\/company\/([^/?#]+)/;
const COMPANY_GUEST_PATH_RE = /^\/discover\/([^/?#]+)/;

/**
 * Maps a guest discover URL to the authenticated AppLayout route shown after onboarding.
 */
export function resolvePostOnboardingPath(guestReturnPath: string): string {
  const path = guestReturnPath.trim();
  if (!path || path === "/") {
    return "/shortlist";
  }

  const corridorMatch = path.match(CORRIDOR_GUEST_PATH_RE);
  if (corridorMatch) {
    return `/ecosystem-heads/${corridorMatch[1]}/${corridorMatch[2]}`;
  }

  const expertMatch = path.match(EXPERT_GUEST_PATH_RE);
  if (expertMatch) {
    return `/experts/company/${expertMatch[1]}/profile`;
  }

  const companyMatch = path.match(COMPANY_GUEST_PATH_RE);
  if (companyMatch && companyMatch[1] !== "corridor" && !path.includes("/expert/")) {
    return `/my-discovery/${companyMatch[1]}`;
  }

  return "/shortlist";
}

export function writeGuestAuthReturnPath(returnPath: string, discoverReturnTo?: string) {
  const trimmed = returnPath.trim();
  if (trimmed) {
    sessionStorage.setItem(GUEST_AUTH_RETURN_PATH_KEY, trimmed);
    sessionStorage.setItem(GUEST_AUTH_POST_ONBOARDING_PATH_KEY, resolvePostOnboardingPath(trimmed));
  }
  if (discoverReturnTo?.trim()) {
    sessionStorage.setItem(GUEST_AUTH_DISCOVER_RETURN_TO_KEY, discoverReturnTo.trim());
  }
}

export function readGuestAuthReturnPath(): string | null {
  return sessionStorage.getItem(GUEST_AUTH_RETURN_PATH_KEY);
}

export function readGuestAuthDiscoverReturnTo(): string | null {
  return sessionStorage.getItem(GUEST_AUTH_DISCOVER_RETURN_TO_KEY);
}

export function readGuestAuthPostOnboardingPath(): string | null {
  return sessionStorage.getItem(GUEST_AUTH_POST_ONBOARDING_PATH_KEY);
}

/** @deprecated Use clearGuestAuthIntent */
export function clearGuestAuthReturnPath() {
  clearGuestAuthIntent();
}

export function clearGuestAuthIntent() {
  sessionStorage.removeItem(GUEST_AUTH_RETURN_PATH_KEY);
  sessionStorage.removeItem(GUEST_AUTH_DISCOVER_RETURN_TO_KEY);
  sessionStorage.removeItem(GUEST_AUTH_POST_ONBOARDING_PATH_KEY);
}
